
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mtn-terms-and-conditions",
      function () {
        return require("private-next-pages/mtn-terms-and-conditions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mtn-terms-and-conditions"])
      });
    }
  